import { Link } from "react-router-dom";
import { cn } from "../../lib/utils";

interface ServiceCardProps {
  title: string;
  subtitle?: string;
  description: string;
  imageSrc: string;
  imageAlt?: string;
  href: string;
  className?: string;
}

export function ServiceCard({ title, subtitle, description, imageSrc, imageAlt, href, className }: ServiceCardProps) {
  return (
    <Link 
      to={href}
      className={cn(
        "group relative block h-[480px] w-full overflow-hidden rounded-[24px] bg-gray-900",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2",
        className
      )}
    >
      <img
        src={imageSrc}
        alt={imageAlt || title}
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
        loading="lazy"
      />

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#002B49] via-[#002B49]/40 to-transparent opacity-90 transition-opacity duration-300 group-hover:opacity-100" />

      {/* Content Container */}
      <div className="absolute inset-0 flex flex-col justify-end p-8">
        {/* Text Content */}
        <div className="transform transition-transform duration-300 ease-out group-hover:-translate-y-2">
          <h3 className="mb-2 text-3xl font-bold text-white tracking-tight">
            {title}
          </h3>
          
          {subtitle && (
            <p className="mb-4 text-lg font-medium text-white/90">
              {subtitle}
            </p>
          )}
          
          <p className="text-base leading-relaxed text-white/80 line-clamp-3">
            {description}
          </p>
        </div>
      </div>
    </Link>
  );
}
